import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { ResourceType, useSetFieldsMutation } from '../../resources';

interface UpdateUserTimezoneVariables {
	userId: string;
	timezone: string;
}

interface UpdateUserTimezoneResponse {
	_id: string;
	timezone?: string;
}

export const useUpdateUserTimezoneMutation = <TError = unknown, TContext = unknown>(
	options?: UseMutationOptions<UpdateUserTimezoneResponse, TError, UpdateUserTimezoneVariables, TContext>
) => {
	const { mutateAsync: setFields } = useSetFieldsMutation({
		resourceType: ResourceType.USERS,
		responseFields: ['_id', 'timezone'],
	});

	return useMutation<UpdateUserTimezoneResponse, TError, UpdateUserTimezoneVariables, TContext>(
		async ({ userId, timezone }) =>
			setFields({
				resourceId: userId,
				fields: { timezone },
			}) as Promise<UpdateUserTimezoneResponse>,
		options
	);
};
